var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-tracker" }, [
    _vm._m(0),
    _c(
      "div",
      {
        staticClass: "dashboard-widget-bodies",
        class: { "fix-height": _vm.isCombo, "single-height": !_vm.isCombo },
      },
      _vm._l(_vm.data, function (items, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "dashboard-widget-body",
            attrs: { "data-tab": "tracker", "data-widget": "2" },
          },
          [
            _c("h3", [_vm._v(_vm._s(_vm._f("capitalize")(index)))]),
            items.length == 0 && index == "today"
              ? _c("div", [
                  _c("div", { staticClass: "empty-data" }, [
                    _vm._v("There has been no activity today."),
                  ]),
                ])
              : _vm._e(),
            items.length == 0 && index == "yesterday"
              ? _c("div", [
                  _c("div", { staticClass: "empty-data" }, [
                    _vm._v("There has been no activity yesterday."),
                  ]),
                ])
              : _vm._e(),
            _vm._l(items, function (item) {
              return _c(
                "div",
                {
                  key: item.projectId,
                  staticClass: "dashboard-widget-due-date",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-11",
                      class: { "pl-0": _vm.isCombo, "pl-25": !_vm.isCombo },
                    },
                    [
                      item.type === "ADDED_COMMENT"
                        ? _c("div", { staticClass: "display-inline" }, [
                            _c("div", { staticClass: "widget-icon" }, [
                              _c("i", { staticClass: "fa fa-comment-o" }),
                              _c("span", { staticClass: "badge" }, [
                                _vm._v(_vm._s(item.count)),
                              ]),
                            ]),
                            _c(
                              "a",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.redirect(item.nextUrl)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.title) + " has new comments")]
                            ),
                          ])
                        : _vm._e(),
                      item.type === "EXPORT_QUEUED"
                        ? _c("div", { staticClass: "display-inline" }, [
                            _vm._m(1, true),
                            _c(
                              "a",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.redirect(item.nextUrl)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(item.title) + " has been exported"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            }),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-widget-tabs" }, [
      _c("img", {
        staticClass: "submission-icons",
        attrs: { src: "/static/images/icons/submission_icon_blue.svg" },
      }),
      _c("span", [_vm._v("Activity Tracker")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "widget-icon" }, [
      _c("img", {
        staticClass: "calender-icon",
        attrs: { src: "/static/images/icons/export.svg" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }